/**
 * SidebarNavigationItemLink
 */
import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { FiChevronDown } from 'react-icons/fi';

// Components
import SidebarNavigationItemIcon from '../SidebarNavigationItemIcon';

// Actions
import { pushWithStoredSearch } from '../../../../../../services/router/actions';

// Selectors
import { makeSelectIsActive } from './selectors';

interface Props {
    iconName: string;
    title: string;
    pathname?: string;
    pushWithStoredSearch: Function;
    isActive: boolean;
    onClick?: Function;
    expanded?: boolean;
    sideEffect?: Function;
    onMouseEnter?: Function;
    onMouseLeave?: Function;
}

export class SidebarNavigationItemLink extends React.Component<Props, State> {
    handleClick = (event) => {
        event.preventDefault();
        const { pathname, onClick, sideEffect } = this.props;
        if (onClick) {
            onClick();
        } else {
            this.props.pushWithStoredSearch(pathname);
        }

        if (sideEffect) {
            sideEffect();
        }
    };

    render() {
        const {
            pathname,
            iconName,
            title,
            isActive,
            onClick,
            expanded,
            onMouseEnter,
            onMouseLeave
        } = this.props;

        return (
            <a
                href={pathname}
                onClick={this.handleClick}
                className={[
                    'sidebar-navigation-item link',
                    isActive ? 'selected' : ''
                ].join(' ')}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                <SidebarNavigationItemIcon iconName={iconName} />
                <div className="sidebar-navigation-item-title">
                    {title}
                    {onClick && (
                        <div
                            className={[
                                'sidebar-navigation-item-title-icon',
                                expanded ? 'expanded' : ''
                            ].join(' ')}
                        >
                            <FiChevronDown size="22" style={{ height: 45 }} />
                        </div>
                    )}
                </div>
            </a>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    isActive: makeSelectIsActive()
});

export default connect(mapStateToProps, { pushWithStoredSearch })(
    SidebarNavigationItemLink
);
